import { Delete, EditCalendarOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import {caseInsensitiveSort} from "../../common/Utils";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import { Link } from "react-router-dom";


export const careUsersColumns = ({ handleDelete, handleResendEmail, userAccessRole }) => [	
	{
		name: 'User Name',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.userName}</div>,
		minWidth:"220px",
		center:true,
		wrap: true,
        sortable: true,
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.userName? row.userName:""),
		style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"220px",
        },
		headerStyle: {
			justifyContent: "center"
		}
	},
	{
		name: 'First Name',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.firstName}</div>,
		minWidth:"160px",
		center:true,
        sortable: true,
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.firstName? row.firstName :""),
		style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"160px",
        },
		headerStyle: {
			justifyContent: "center",
			width: "150px"
		},
		align:"center"
	},
	{
		name: 'Last Name',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.lastName}</div>,
        sortable: true,
		minWidth:"160px",
		center:true,
		wrap: true,
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.lastName ? row.lastName.toLowerCase(): ""),
		style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"160px",
        },
		headerStyle: {
			justifyContent: "center",
			width: "150px"
		}
	},
	{
		name: 'Status',
        sortable: true,
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.emailVerificationStatus}</div>,
		wrap: true,
		minWidth:"250px",
		center:true,
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.emailVerificationStatus ? row.emailVerificationStatus.toLowerCase(): ""),
		style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"250px",
        },
		headerStyle: {
			justifyContent: "center"
		},
		cell: row => 
		
		 row.emailVerificationStatus !== 'Active' && row.emailVerificationStatus !== 'Email Verification Pending' && row.emailVerificationStatus === 'Verification Link Expired'?
		 <div> {row.emailVerificationStatus} <IconButton sx={{ boxShadow:'none'}} onClick={() => handleResendEmail(row)}><ForwardToInboxIcon/></IconButton></div>
		 : row.emailVerificationStatus 

		 /*cell: row => 
		
		 row.emailVerificationStatus !== 'Active' && row.emailVerificationStatus !== 'Email Verification Pending' && row.emailVerificationStatus === 'Verification Link Expired'?
		 <div> {row.emailVerificationStatus} <IconButton sx={{ boxShadow:'none'}} onClick={() => handleResendEmail(row)}><ForwardToInboxIcon/></IconButton></div>
		 : row.emailVerificationStatus !== 'Active' && row.emailVerificationStatus === 'Email Verification Pending' && row.emailVerificationStatus !== 'Verification Link Expired'?
		  <div> {row.emailVerificationStatus} <IconButton sx={{ boxShadow:'none'}} onClick={() => handleRefreshStatus(row)}><Refresh color="success"/></IconButton></div>
		 : row.emailVerificationStatus */
	},
	{
		name: 'Updated By',
        sortable: true,
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.updatedBy}</div>,
		minWidth:"230px",
		center:true,
		wrap: true,
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.updatedBy? row.updatedBy: ""),
		style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"230px",
        },
		headerStyle: {
			justifyContent: "center"
		}
	},
	{
		name: 'Updated Date',
        sortable: true,
		minWidth:"160px",
		center:true,
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.updatedDate}</div>,
		wrap: true,
		style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"160px",
        },
		headerStyle: {
			justifyContent: "center"
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.updatedDate ? row.updatedDate :""),
	},
	{
		name: 'Action',
		wrap: true,
		minWidth:'100px',
		center:true,
		omit: userAccessRole === "" || userAccessRole === "Read" || userAccessRole === undefined || userAccessRole === null,
		style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"100px",
        },
		cell: row => 
			<div style={{display:"flex", flexDirection:"row"}}>
			<Link to="/admin/newClientUser/edit" state={row}>
							<IconButton sx={{ boxShadow:'none'}} title="Edit">
								<EditCalendarOutlined sx={{ color:'#002d82'}} />
							</IconButton>
			</Link>

			<IconButton sx={{ boxShadow:'none'}}  onClick={() => handleDelete(row)}>
			<Delete sx={{ color:'#cd5c5c'}} />
			</IconButton>
			</div>
	}
];

export const exportCareFacilityUserColumns=[	
	{
		header: 'User Name',
		key: 'userName',
	},
	{
		header: 'Care Facility',
		key: 'careFacilityName'
	},
	{
		header: 'Parent Company',
		key: 'parentCompanyName'
	},
	{
		header: 'First Name',
		key: 'firstName',
	},
	{
		header: 'Last Name',
		key: 'lastName',
	},
	{
		header: 'Status',
		key: 'emailVerificationStatus',
	},
	{
		header: 'Updated By',
		key: 'updatedBy',
	},
	{
		header: 'Updated Date',
		key: 'updatedDate',
	},
]